import React, { Component } from 'react';

import { Form, Input, InputNumber, Checkbox, Button, Modal, Select, Divider, Switch, Icon } from 'antd';

const FormItem = Form.Item;

class IntelliportCommandsCreateForm extends Component {

  state = {
    modalVisible: false,
    command_parameters_required: true
  }

  form = null;
  lastCommandType = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="PID senzoru" >
          {getFieldDecorator('sensor_pid', {
            initialValue: this.props.initialValues && this.props.initialValues.pid
              ? this.props.initialValues.pid
              : null,
          })(
            <Input disabled />
          )}
        </FormItem>

        <FormItem
          {...formItemLayout}
          label="Sériové číslo senzoru" >
          {getFieldDecorator('sensor_serial_number', {
            initialValue: this.props.initialValues && this.props.initialValues.serial_number
              ? this.props.initialValues.serial_number
              : null,
          })(
            <Input disabled />
          )}
        </FormItem>

        <FormItem
            {...formItemLayout}
            label="Typ příkazu" >
            {getFieldDecorator('command_type', {
                initialValue: this.props.initialValues && this.props.initialValues.command_type
                    ? this.props.initialValues.command_type
                    : null,
                rules: [{
                    required: true, message: 'Vyplňte prosím tuto položku!',
                }],
            })(
                <Select
                    onChange={(value) => {
                        if (this.lastCommandType == value) {return}

                        if (value === '2') {
                            this.setState({ command_parameters_required: false });
                            this.props.form.setFieldsValue({
                                command_parameters: '---'
                            });
                        } else {
                            this.setState({ command_parameters_required: true });
                            this.props.form.setFieldsValue({
                                command_parameters: ''
                            });
                        }
                    }}
                >
                    <Select.Option value="48">Get Parameters</Select.Option>
                    <Select.Option value="43">Set parameters</Select.Option>
                    <Select.Option value="2">Request RF params</Select.Option>
                    <Select.Option value="50">Start/Stop firmware update</Select.Option>
                </Select>
            )}
        </FormItem>

        <FormItem
            {...formItemLayout}
            label="Priorita" >
            {getFieldDecorator('priority', {
                initialValue: this.props.initialValues && this.props.initialValues.priority
                    ? this.props.initialValues.priority
                    : null,
                rules: [{
                    required: true, message: 'Vyplňte prosím tuto položku!',
                }],
            })(
                <InputNumber min={0} max={255} />
            )}
        </FormItem>

        <FormItem
            {...formItemLayout}
            label="Parametry příkazu" >
            {getFieldDecorator('command_parameters', {
                initialValue: this.props.initialValues && this.props.initialValues.command_parameters,
                rules: [{
                    required: true, message: 'Vyplňte prosím tuto položku!',
                }],
            })(
                <Input 
                    disabled={this.state.command_parameters_required ? false : true}
                />
            )}
        </FormItem>

        <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Vytvořit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={700}
          title={"Vytvoření příkazu"}
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText={"Vytvořit"}
        >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(IntelliportCommandsCreateForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/IntelliportCommandsCreateForm.js